/**
 * Labstep
 *
 * @module components/ResourceLocation/Pane
 * @desc Resource location pane
 */

import { ResourceLocationActionCreateModal } from 'labstep-web/components/ResourceLocation/Action/Create/Modal';
import { ResourceLocationPaneList } from 'labstep-web/components/ResourceLocation/Pane/List';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { Flex } from 'labstep-web/core/Flex';
import { Header } from 'labstep-web/core/Header';
import { Icon } from 'labstep-web/core/Icon';
import { Link } from 'labstep-web/core/Link';
import type React from 'react';
import type { IResourceLocationPaneProps } from './types';

export const viewComponent = (
  <Flex style={{ justifyContent: 'space-between' }}>
    <Header size="tiny">
      <Icon name={ICONS.resource_location.primary} /> Locations
    </Header>
    <Link unstyled to="resource_location_index">
      <ActionComponent
        type="icon"
        icon="cog"
        elementProps={{
          popup: { content: 'Manage Locations' },
        }}
      />
    </Link>
  </Flex>
);

export const ResourceLocationPane: React.FC<
  IResourceLocationPaneProps
> = ({ usePostFilter }) => (
  <div>
    <ResourceLocationPaneList
      action={
        <ResourceLocationActionCreateModal
          actionComponentProps={{
            icon: ICONS.entity.actions.create,
            type: 'text',
          }}
        />
      }
      searchBarProps={{
        viewComponent,
      }}
      usePostFilter={usePostFilter}
    />
  </div>
);
